export type ApDocumentType = "invoice" | "receipt";

export type ApInvoiceStatus =
  | "pending_parse"
  | "parsing"
  | "parsed"
  | "matching"
  | "matched"
  | "match_failed"
  | "parse_failed";

export type ApReviewStatus =
  | "pending_review"
  | "approved"
  | "applying"
  | "applied"
  | "rejected"
  | "superseded"
  | "apply_failed";

export type ApRollbackStatus =
  | "not_rolled_back"
  | "rolling_back"
  | "rolled_back"
  | "rollback_failed"
  | "rollback_blocked";

export type ApItemType = "material" | "equipment";

export type ApJobMatchStrategy =
  | "purchase_order"
  | "job_number"
  | "customer_name"
  | "agent"
  | "manual"
  | "non_job";

export const AP_ACTION_TYPE = {
  createPo: "create_po",
  createPricebookItem: "create_pricebook_item",
  createQboBill: "create_qbo_bill",
  createReturn: "create_return",
  createReceipt: "create_receipt",
  cancelReceipt: "cancel_receipt",
  replaceReceipt: "replace_receipt",
  flagForReview: "flag_for_review",
  linkVendor: "link_vendor",
  markNonJob: "mark_non_job",
  matchJob: "match_job",
  mergeVendor: "merge_vendor",
  noAction: "no_action",
  updatePo: "update_po",
  updatePricebookCost: "update_pricebook_cost",
  updateQboBill: "update_qbo_bill",
} as const;

export type ApActionType = (typeof AP_ACTION_TYPE)[keyof typeof AP_ACTION_TYPE];

export type ApAgentRunStatus = "pending" | "running" | "completed" | "failed";

export type ApAutomationQualification =
  | "disqualified"
  | "qualified_skipped"
  | "qualified_selected";

export type ApEmailStatus =
  | "received"
  | "processing"
  | "processed"
  | "partial_failure"
  | "failed";

export type ApAttachmentStatus =
  | "pending"
  | "classifying"
  | "is_invoice"
  | "is_receipt"
  | "not_invoice"
  | "download_failed"
  | "classification_failed"
  | "unsupported_type";
